export const MIME_TYPE_ICONS = {
  'application/vnd.google-apps.presentation': 'googleslide',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint',
  'application/vnd.ms-powerpoint': 'PowerPoint',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel2026',
  'application/pdf': 'document',
  'image/jpeg': 'image',
  'image/png': 'image',
}

const EXTENSION_ICONS = {
  ppt: 'PowerPoint',
  pptx: 'PowerPoint',
  xls: 'Excel2026',
  xlsx: 'Excel2026',
  pdf: 'document',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
}

export const DEFAULT_FILE_ICON = 'document'

export function getFileTypeIconName({ mimeType, filename } = {}) {
  if (mimeType && MIME_TYPE_ICONS[mimeType]) return MIME_TYPE_ICONS[mimeType]

  const ext =
    filename && filename.includes('.')
      ? filename.split('.').pop().toLowerCase()
      : ''
  if (ext && EXTENSION_ICONS[ext]) return EXTENSION_ICONS[ext]

  return DEFAULT_FILE_ICON
}
